"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxOverrides = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _dist = require("@aaa-ncnu-ie/icons/dist");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var checkboxOverrides = {
  MuiCheckbox: {
    defaultProps: {
      color: 'secondary',
      size: 'small',
      icon: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
        component: _dist.CheckboxUnselected
      }),
      checkedIcon: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
        component: _dist.CheckboxSelected
      }),
      indeterminateIcon: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
        component: _dist.CheckboxIndeterminate
      })
    },
    styleOverrides: {
      root: function root(_ref) {
        var _ref$theme = _ref.theme,
          palette = _ref$theme.palette,
          spacing = _ref$theme.spacing;
        return {
          // .MuiCheckbox-root
          padding: spacing(0.5),
          '&:hover': {
            backgroundColor: (0, _styles.alpha)(palette.grey['1000'], palette.action.hoverOpacity)
          },
          '&.Mui-focusVisible': {
            backgroundColor: (0, _styles.alpha)(palette.grey['1000'], palette.action.focusOpacity)
          },
          '&:active': {
            backgroundColor: (0, _styles.alpha)(palette.grey['1000'], palette.action.activatedOpacity)
          },
          '&.Mui-disabled': {
            color: palette.action.disabled
          },
          '.MuiSvgIcon-fontSizeSmall': {
            fontSize: 12
          }
        };
      }
    }
  }
};
exports.checkboxOverrides = checkboxOverrides;